export default __webpack_public_path__ + "static/media/559.f20afb0a.jpg";